export default "__VITE_ASSET__fJtBESR6gf81ETa80lSrgQ__"